import { cloneDeep } from "lodash";
import { getAudioForPhonemes } from "./phonemeToAudio";

export async function sleep(ms = 1000) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}

export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
}

//Get a random element from an array
export function getRandomArrayElement(inArray) {
  let randomElement = inArray[getRandomInt(0, inArray.length)];
  return randomElement;
}

// clone and then shuffle an array
export function shuffle(inArray) {
  const arr = cloneDeep(inArray);
  return arr.sort(() => 0.5 - Math.random());
}

// get n random non-overlapping elements from an array
export function getRandomElements(pool, n) {
  return shuffle(pool).slice(0, n);
}

export function dedupe(inArray) {
  return [...new Set(inArray)];
}

export function isVowel(g) {
  return ["a", "e", "i", "o", "u"].includes(g);
}

export function spell(letters) {
  let tts = "";
  for (const char of letters) tts += `${char}. `;
  return tts;
}

export function getSyllables(PHON, GRAPHEMIC_BREAKDOWN, locale) {
  const phonSyllables = PHON.split("/");
  const graphemes = GRAPHEMIC_BREAKDOWN.split("/");
  const syllables = [];
  let i = 0;
  for (const phonSyllable of phonSyllables) {
    const files = getAudioForPhonemes(phonSyllable, locale);
    const graphemeCount = files.length;
    const syllable = graphemes.slice(i, i + graphemeCount).join("");
    i += graphemeCount;
    syllables.push(syllable);
  }
  return syllables;
}

export function isDerangement(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;
  for (let i = 0; i < arr1.length; i++) if (arr1[i] === arr2[i]) return false;
  return true;
}